
export class LoadingSpinner {

    private static _spinnerEl: HTMLElement;
    private static leaseCount = 0;
    private static delayedShow: any | null = null
    private static delayedShowIntervalMs = 500;
    private static hideNotBefore: number = -1;

    private static get spinnerEl(): HTMLElement {
        if (!LoadingSpinner._spinnerEl) {
            LoadingSpinner._spinnerEl = document.getElementById('app-loading-spinner')!;
        }
        return LoadingSpinner._spinnerEl;
    }

    private static show() {
        if (LoadingSpinner.spinnerEl.style.display === 'none') {
            LoadingSpinner.hideNotBefore = Date.now() + 500;
        }
        LoadingSpinner.spinnerEl.style.display = 'flex';
    }

    private static hide() {
        if (Date.now() < LoadingSpinner.hideNotBefore) {
            setTimeout(() => {
                LoadingSpinner.spinnerEl.style.display = 'none';
            }, LoadingSpinner.hideNotBefore - Date.now());
        } else {
            LoadingSpinner.spinnerEl.style.display = 'none';
        }
        LoadingSpinner.hideNotBefore = -1;
    }

    static lease() {
        LoadingSpinner.leaseCount++;
        if (!LoadingSpinner.delayedShow) {
            LoadingSpinner.delayedShow = setTimeout(LoadingSpinner.delayedShowHandler, LoadingSpinner.delayedShowIntervalMs)
        }
    }

    private static delayedShowHandler() {
        LoadingSpinner.delayedShow = null;
        if (LoadingSpinner.leaseCount > 0) {
            LoadingSpinner.show();
        }
    }

    static release() {
        if (LoadingSpinner.leaseCount > 0) LoadingSpinner.leaseCount--;
        if (LoadingSpinner.leaseCount === 0) {
            if (!LoadingSpinner.delayedShow) {
                clearTimeout(LoadingSpinner.delayedShow!);
                LoadingSpinner.delayedShow = null;
            }
            LoadingSpinner.hide();
        }
    }

    static async withSpinnerAsync<T>(fn: () => Promise<T>): Promise<T> {
        LoadingSpinner.lease();
        try { return await fn(); }
        finally { LoadingSpinner.release(); }
    }

    static withSpinner<T>(fn: () => T): T {
        LoadingSpinner.lease();
        try { return fn(); }
        finally { LoadingSpinner.release(); }
    }
}
